document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  for (const details of document.querySelectorAll('[data-n4-language][open]')) {
    if (!details.contains(event.target)) details.open = false;
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  for (const details of document.querySelectorAll('[data-n4-language][open]')) {
    details.open = false;
    details.querySelector('summary')?.focus();
    event.stopPropagation();
  }
});

function n4CountryFlagFallback() {
  let supportsFlags = false;
  try {
    const context = document.createElement('canvas').getContext('2d');
    if (context) {
      context.font = '32px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif';
      supportsFlags = context.measureText('🇫🇷').width < context.measureText('🇫').width + context.measureText('🇷').width - 1;
    }
  } catch {}
  if (supportsFlags) return;
  for (const label of document.querySelectorAll('.n4-country [data-n4-country-name]')) {
    const code = label.value || label.dataset.n4CountryCode;
    label.textContent = `\u2068[${code}]\u2069 ${label.dataset.n4CountryName}`;
  }
}
n4CountryFlagFallback();
document.addEventListener('shopify:section:load', n4CountryFlagFallback);
